import {
    createContext,
    useState,
    useEffect,
    useContext,
} from "react";
import { useRouter } from "next/router";
import BusinessContext from "./business-context";
import { renderTables, OnCreateTable, renderRecentTables, addRecentTables, onCreateRow, renderRows, renderPegs } from "../lib/table";

const TableContext = createContext({
    tables: [],
    setTables: () => { },
    createTable: () => { },
    fetchTables: () => { },
    newTableId: null,
    setNewTableId: () => { },
    refreshNewTableId: () => { },
});

export const TableProvider = (props) => {
    const [tables, setTables] = useState(null);
    const [newTableId, setNewTableId] = useState(null);
    const router = useRouter();
    const { activeBusiness } = useContext(BusinessContext);
    const [peg, setPeg] = useState(null);



    const fetchPegs = () => {
        const callback = (json) => {
            setPeg(json[0]);
        }
        const onError = (json) => {
            console.error(json);
        }
        renderPegs(callback, 'developers', onError, router);
    }

    const refreshNewTableId = () => {
        setNewTableId(null);
    }

    const createTable = (type, callback) => {
        const onError = (json) => {
            console.error(json);
        };
        let schema;
        const baseSchema = {
            "owner": 1,
            "business_permission": 4,
            peg: peg ? peg.id : null,
            "individual_permissions": [],
            "public_permission": 0
        };

        if (type === 'agreement') {
            schema = {
                ...baseSchema,
                "namespace": 'agreement',
                "columns": [
                    {
                        "name": "Agreement Status",
                        "type": "mutable_select",
                        "options": {
                            "choices": [
                                { "ref": "accepted", "tag": "Accepted" },
                                { "ref": "rejected", "tag": "Rejected" }
                            ]
                        },
                        "position": 1000.0
                    }
                ],
                "name": "Developers Agreement",
                "metadata": {}
            };
        }
        OnCreateTable(schema, callback, activeBusiness, onError, router);
    }

    const fetchTables = () => {
        const callback = (json) => {
            setTables(json.filter(table => table.namespace !== 'agreement'));
        }
        const onError = (json) => {
            console.error(json);
            setIsCheckingAgreement(false);
        }
        renderTables(callback, activeBusiness, onError, router, 'developers')
    }

    useEffect(() => {
        // if (activeBusiness) {
        //     if (!peg) {
        //         fetchPegs();
        //     }
        //     if (!tables) {
        //         fetchTables();
        //     }
        // }
    }, [activeBusiness, router, peg]);




    const context = {
        tables,
        setTables,
        createTable,
        fetchTables,
        newTableId,
        setNewTableId,
        refreshNewTableId,
    };

    return (
        <TableContext.Provider value={context}>
            {props.children}
        </TableContext.Provider>
    );
};

export default TableContext;